
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47.045 61.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.817 5.227h-2.613V0h-5.227v5.227h-20.91V0H7.842v5.227H5.227A5.226 5.226 0 000 10.454v36.59a5.227 5.227 0 005.227 5.227h12.006a10.144 10.144 0 01-1.626-3.832 2.64 2.64 0 01-1.492-1.395H5.227V18.295h36.59v28.75h-8.884a2.67 2.67 0 01-1.329 1.363 10.087 10.087 0 01-1.626 3.864h11.84a5.227 5.227 0 005.227-5.227v-36.59a5.227 5.227 0 00-5.228-5.228z"}}),_c('path',{attrs:{"d":"M31.363 23.522h5.227v5.227h-5.227zM20.909 23.522h5.227v5.227h-5.227zM10.454 23.522h5.227v5.227h-5.227z"}}),_c('path',{staticClass:"user",attrs:{"d":"M31.805 54.244l-3.718-.93-.206-.824a7.724 7.724 0 001.916-3.794 2.05 2.05 0 001.18-1.606l.262-2.09a2.042 2.042 0 00-.982-2.004l.072-1.464.274-.274a2.879 2.879 0 00.106-3.842 4.825 4.825 0 00-4.354-2.016 7.38 7.38 0 00-4.102 1.048c-4.76.146-5.38 2.55-5.38 4.646 0 .414.08 1.228.15 1.864a2.024 2.024 0 00-.542.436 2.045 2.045 0 00-.498 1.608l.262 2.086a1.998 1.998 0 001.304 1.632 7.773 7.773 0 001.816 3.672l-.23.922-3.718.93a6.333 6.333 0 00-4.808 6.156 1 1 0 001 1h24a1.002 1.002 0 001-1.002 6.332 6.332 0 00-4.804-6.154z"}})])
          )
        }
      }
    